import React from 'react'
import { Box, Button, Checkbox, FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material'
import { Item, SuccessPopUp1 } from '../../../../common/snippets'
import DropDownOA from '../../../../common/dropDownOA'
import Datepicker from '../../../../common/datePicker'
import { SplitButton } from '../../../../common/SplitButton'
import { RefreshSvg } from '../../../../common/svg/refresh'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import * as id from '../../reportId'
import * as lb from '../../reportLables'
import { useState } from 'react'
import { paymentModesWithAll } from '../../../../common/paymentsMode'
import { getOwnBookingFilterData, getOwnBookingTableData, getCargoSettingFilterData } from '../../../../../store/reports/reports_action'
import { connect } from 'react-redux'
import { lrStatusView, reportView, transType, urls } from '../../../../common/constants'
import { useEffect } from 'react'
import moment from 'moment/moment'
import { navigation3, appendToUrl, diffInMonths, focusElemnt, isEmpty, removeDuplicatesFromArray } from '../../../../common/helper'
import * as urlValue from '../../oldReportsUrls'
import { updateAlert, updateAlertError, updateModal } from '../../../../../store/common/common_action'
import { ownBookingDetailedColumnsWithFormattedLRTwo, ownBookingDetailedColumnsForPotrate, bookingSummaryColumn, ownBookingDetailedColumnsForLeyma, excelHeader1 } from '../BookingConstants'
import { devideInTwoIntegers, divideInNIntegers } from '../../../../common/mathHelper'
import { GT_COMPANY_ID, URVASHI_TRAVELS} from '../../../../../helper/companyIdhardcode'
import { ChildCompanyListData, fetchChildCompanyListData } from '../../../../common/jotaiState/reportStateAtom'
import { useAtom, useSetAtom } from 'jotai'
import { globalLoaderAtom } from '../../../../common/jotaiState/globalStateAtoms'
import { GetRequest, PostRequest } from '../../../../common/api'
import { downloadPDF } from '../../analysisReport/pdfAutotable'
import { companySettingsAtom } from '../../../../common/jotaiState/commonStateAtoms'

const OwnBookingsNew = (props) => {
    const {
        data: { common = {}, reports = {} } = {},
        getOwnBookingFilterData,
        getOwnBookingTableData,
        getCargoSettingFilterData,
        updateAlert,
        updateAlertError,
        updateModal,
        isFromUrl,
        loginData = {},
        roleRightsData = {},
        companySettingsData = []
    } = props
    const { showModal, modalType } = common
    const [companySettings] = useAtom(companySettingsAtom)
    const resolvedCompanySettings =
        companySettingsData?.length
            ? companySettingsData
            : !isEmpty(companySettings)
                ? [companySettings]
                : common?.companySettings || []
    const { AllowGroupofCompanies = 0 } = roleRightsData
    const { intCompanyID, intUserID } = loginData || {}
    const loginCountryId = resolvedCompanySettings?.[0]?.DefaultCurrencyID || 0
    const UseFormattedLRinReports = resolvedCompanySettings?.[0]?.UseFormattedLRinReports|| 0
    const BookingReportPortrait = resolvedCompanySettings?.[0]?.BookingReportPortrait || 0
    const { ownBookingDropData, ownBookingTableData, cargoSettingFilterData } = reports
    const { DefaultCurrencyID, IsHamaliInBookingReport, UseToPayAsCOD } = resolvedCompanySettings?.[0] || {}
    const setLoader = useSetAtom(globalLoaderAtom)
    const summaryheaders = bookingSummaryColumn.filter(col => {
        if (DefaultCurrencyID === 2 && col.field === 'BookingGST') return false;
        if (!IsHamaliInBookingReport && col.field === 'HamaliCharges') return false;
        return true;
    }).map(col => {
        if (col.field === 'Valuation') {
            return {
                ...col,
                headerName: DefaultCurrencyID === 2 ? 'Insurance\nCharge' : 'Valuation\nCharge',
                exportHead: DefaultCurrencyID === 2 ? 'Insurance\nCharge' : 'Valuation\nCharge',
            };
        }
        if (col.field === 'CartageAmount' && loginData?.intCompanyID === GT_COMPANY_ID) {
            return {
                ...col,
                headerName: 'Addl. \nCartage',
                exportHead: 'Addl. \nCartage',
            };
        }
        return col;
    });
    const [clickButton, setClickButton] = useState('')
    const [showReport, setShowReport] = useState(false)
    const [tableData, setTableData] = useState([])
    const [manageColumn, setManageColumn] = useState([])
    const [selCompany, setSelCompany] = useState('')
    const [fromDate, setFromDate] = useState(moment(new Date()))
    const [toDate, setToDate] = useState(moment(new Date()))

    const [sourceCity, setSourceCity] = useState('')
    const [sourceCityData, setSourceCityData] = useState([])

    const [sourceBranch, setSourceBranch] = useState('')
    const [sourceBranchData, setSourceBranchData] = useState([])

    const [sourceBranchUser, setSourceBranchUser] = useState('')
    const [sourceBranchUserData, setSourceBranchUserData] = useState([])

    const [destinationCity, setDestinationCity] = useState('')
    const [destinationCityData, setDestinationCityData] = useState([])
    const [destinationBranch, setSelDestinationBranch] = useState('')
    const [destinationBranchdata, setSelDestinationBranchdata] = useState([])

    const [paymentType, setPaymentType] = useState(paymentModesWithAll?.[0])
    const [paymentOptions, setPaymentOptions] = useState([]);
    const [transactionType, setTransactionType] = useState(transType?.[0])
    const [selReportView, setSelReportView] = useState(reportView?.[1])
    const [status, setStatus] = useState(lrStatusView?.[0])
    const [checkCrossinglr, setCheckCrossinglr] = useState(false)
    const [disableBtn, setDisableBtn] = useState(false)
    const [disableExcel, setDisableExcel] = useState(false)
    const [, fetchChildCompanyList] = useAtom(fetchChildCompanyListData)
    const [ChildCompanyList] = useAtom(ChildCompanyListData)
    const reportName = 'Own Booking Report'
    const filterItemSx = isFromUrl ? sx.itemsxGrow : sx.itemsx
    const filterInputWidth = isFromUrl ? '100%' : '170px'
   
    const reset = () => {
        setFromDate(moment(new Date()))
        setToDate(moment(new Date()))
        setSourceCity(' ')
        setSourceBranch(' ')
        setSourceBranchUser(' ')
        setDestinationCity(' ')
        setSelDestinationBranch(' ')
        setPaymentType([paymentModesWithAll?.[0]])
        setTransactionType(transType?.[0])
        setSelReportView(reportView?.[1])
        setStatus(lrStatusView?.[0])
        setCheckCrossinglr(false)
    }
    const handleGoClick = () => {
        if (Math.abs(toDate.diff(fromDate, 'days')) > 31) {
            updateAlertError({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' })
        } else {
            setClickButton('Go')
            const obj = {
                CompanyID: selCompany?.CompanyID,
                FromDate: moment(fromDate).format('YYYY-MM-DD'),
                ToDate: moment(toDate).format('YYYY-MM-DD'),
                FranchCompID: 0,
            }
            setLoader(true)
            GetRequest(urls.getOwnBookingFilterData, obj)
                .then((res) => {
                    setLoader(false)
                    if (res.status == 'Success') {
                        const table = res?.Data?.Table || []

                        if (table.length >= 1) {
                            const SourceCity = removeDuplicatesFromArray(
                                table.map((v) => ({
                                    SourceCityName: v.SourceCityName,
                                    SourceCityID: v.SourceCityID,
                                })),
                                'SourceCityID'
                            )

                            const SourceBranch = removeDuplicatesFromArray(
                                table.map((v) => ({
                                    SourceBranchName: v.SourceBranchName,
                                    SourceBranchID: v.SourceBranchID,
                                    SourceCityID: v.SourceCityID,
                                })),
                                'SourceBranchID'
                            )

                            const SourceBranchUser = removeDuplicatesFromArray(
                                table.map((v) => ({
                                    UserBooked: v.UserBooked,
                                    UserID: v.UserID,
                                    SourceBranchID: v.SourceBranchID,
                                })),
                                'UserID'
                            )

                            const DestinationCity = removeDuplicatesFromArray(
                                table.map((v) => ({
                                    DestCityName: v.DestCityName,
                                    DestCityID: v.DestCityID,
                                })),
                                'DestCityID'
                            )

                            const DestinationBranch = removeDuplicatesFromArray(
                                table.map((v) => ({
                                    DestBranchName: v.DestBranchName,
                                    DestBranchID: v.DestBranchID,
                                    DestCityID: v.DestCityID,
                                })),
                                'DestBranchID'
                            )
                            if (disableBtn) {
                                setSourceCity({ SourceCityName: loginData?.strCityName, SourceCityID: loginData?.intBranchCityID })
                                if (disableBtn && roleRightsData?.AllowViewAllBranchOfCityReport == 1) {
                                    const selectedBranch = SourceBranch?.filter((val) => val.SourceBranchID === loginData?.intBranchID)
                                    const selectedUser = SourceBranchUser?.filter((val) => val.UserID === loginData?.intUserID)
                                    if (selectedBranch?.length > 0) {
                                        setSourceBranch(selectedBranch?.[0])
                                    } else {
                                        setSourceBranch({ SourceBranchName: 'All Branch', SourceBranchID: 0 })
                                    }
                                    if (selectedUser?.length > 0) {
                                        setSourceBranchUser(selectedUser?.[0])
                                    } else {
                                        setSourceBranchUser({ UserBooked: 'All Branch User', UserID: 0 })
                                    }
                                } else {
                                    setSourceBranch({ SourceBranchName: loginData?.strBranchName, SourceBranchID: loginData?.intBranchID })
                                    setSourceBranchUser({ UserBooked: loginData?.strUserName, UserID: loginData?.intUserID })
                                }
                            } else {
                                const selectedCity = SourceCity?.filter((val) => val.SourceCityID === loginData?.intBranchCityID)
                                const selectedBranch = SourceBranch?.filter((val) => val.SourceBranchID === loginData?.intBranchID)
                                const selectedUser = SourceBranchUser?.filter((val) => val.UserID === loginData?.intUserID)
                                if (selectedCity?.length > 0) {
                                    setSourceCity(selectedCity?.[0])
                                } else {
                                    setSourceCity({ SourceCityName: 'All Cities', SourceCityID: 0 })
                                }
                                if (selectedBranch?.length > 0) {
                                    setSourceBranch(selectedBranch?.[0])
                                } else {
                                    setSourceBranch({ SourceBranchName: 'All Branch', SourceBranchID: 0 })
                                }
                                if (selectedUser?.length > 0) {
                                    setSourceBranchUser(selectedUser?.[0])
                                } else {
                                    setSourceBranchUser({ UserBooked: 'All Branch User', UserID: 0 })
                                }
                            }
                            setSourceCityData([{ SourceCityName: 'All Cities', SourceCityID: 0 }, ...SourceCity])
                            setSourceBranchData([{ SourceBranchName: 'All Branch', SourceBranchID: 0 }, ...SourceBranch])
                            setSourceBranchUserData([{ UserBooked: 'All Branch User', UserID: 0 }, ...SourceBranchUser])
                            setDestinationCityData([{ DestCityName: 'All Cities', DestCityID: 0 }, ...DestinationCity])
                            setSelDestinationBranchdata([{ DestBranchName: 'All Branch', DestBranchID: 0 }, ...DestinationBranch])
                            setDestinationCity({ DestCityName: 'All Cities', DestCityID: 0 })
                            setSelDestinationBranch({ DestBranchName: 'All Branch', DestBranchID: 0 })
                        }
                    } else {
                        updateAlertError({ show: true, msg: res.ErrMessage, nextId: '' })
                    }
                })
                .catch((err) => {
                    setLoader(false)
                })
        }
    }
  
const exportPdf = (reportData,visibleColumns, hideHeader) => {
    downloadPDF({
        reportName,
        criteriaHeaders,
        criteriaData: [criteriaData],
        tableData: reportData,
        visibleColumns,
        showColumnBorders: true,
        loginData: loginData,
        hideHeader,
    })
}
    const fetchData = (isPdf = false) => {
        if (sourceCity == "" || sourceCity == ' ') {
            updateAlertError({ show: true, msg: 'Select Source City', nextId: '' })
        } else if (sourceBranch == "" || sourceBranch == ' ') {
            updateAlertError({ show: true, msg: 'Select Source Branch', nextId: '' })
        } else if (sourceBranchUser == "" || sourceBranchUser == ' ') {
            updateAlertError({ show: true, msg: 'Select Branch User', nextId: '' })
        } else {
            const diffDays = Math.abs(toDate.diff(fromDate, 'days'))
            const isAllSelected =
                sourceCity?.SourceCityID === 0 ||
                sourceBranch?.SourceBranchID === 0 ||
                sourceBranchUser?.UserID === 0
            if (isAllSelected && diffDays > 15) {
                updateAlertError({ show: true, msg: 'For All selection, date range cannot exceed 15 days', nextId: '' })
            } else if (!isAllSelected && diffDays > 31) {
                updateAlertError({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' })
            } else {
                setShowReport(true)
                setClickButton('Generate')
                setLoader(true)
                const object = {
                    CompanyID: selCompany?.CompanyID,
                    SourceCityID: sourceCity?.SourceCityID || 0,
                    SourceBranchID: sourceBranch?.SourceBranchID || 0,
                    DateFrom: moment(fromDate).format('YYYY-MM-DD'),
                    DateTo: moment(toDate).format('YYYY-MM-DD'),
                    UserID: sourceBranchUser?.UserID || 0,
                    DestCityID: destinationCity?.DestCityID || 0,
                    DestBranchID: destinationBranch?.DestBranchID || 0,
                    PaymentTypeIDs: paymentType.typeId || 0,
                    Mode: transactionType?.TransId || 0,
                    StatusCode: status?.LrId || 0,
                    IsCrossingCity: checkCrossinglr ? 1 : 0,
                    LoggedInUser: loginData?.intUserID,
                    AllowViewAllReport: 1,
                }
                GetRequest(urls.getOwnBookingReportData, object)
                    .then((res) => {
                        setLoader(false)
                        if (res.status == 'Success') {
                            const updatedData = {
                                ...res,
                                Data: {
                                    ...res.Data,
                                    Table1: res.Data.Table1.map((item) => ({
                                        ...item,
                                        PayType:
                                            UseToPayAsCOD === 1 &&
                                                item.PaymentTypeID === 2
                                                ? "COD"
                                                : item.PaymentTypeID === 7 ? 'COD(MANUAL)' : item.PayType,
                                    })),
                                    Table: res.Data.Table.map((item) => ({
                                        ...item,
                                        PayType:
                                            UseToPayAsCOD === 1 &&
                                                item.PaymentTypeID === 2
                                                ? "COD"
                                                : item.PaymentTypeID === 7 ? 'COD(MANUAL)' : item.PayType,
                                    })),
                                },
                            };
                            let reportData = formatData(updatedData)
                            if (reportData?.length > 0) {
                                let mainHeader = []
                                let manageColIdValue = ''
                                if (BookingReportPortrait === 1) {
                                    manageColIdValue = 'ownBookingDetailedColumnsPotrate'
                                } else if (DefaultCurrencyID === 2) {
                                    manageColIdValue = 'ownBookingLeymaDetailedColumns21'
                                } else {
                                    manageColIdValue = 'ownBookingDetailedColumns223'
                                }
                                let reportPayload = {}
                                if (selReportView?.ReportView === 'Detailed') {
                                    mainHeader = manageColumn.filter((obj) => obj.isSelected)?.map((val) => ({
                                        ...val,
                                        align: val.headerSx.textAlign,
                                        export: val.exportHead,
                                        weight: 80
                                    }))
                                   const markerField = getLastNonNumericField(mainHeader)
                                   let allHeaders = manageColumn?.map((val) => ({
                                        ...val,
                                        align: val.headerSx.textAlign,
                                        export: val.exportHead,
                                        weight:val?.weight?? 80
                                    }))
                                    reportPayload = {
                                        reportName,
                                        criteriaHeaders: criteriaHeaders,
                                        criteriaData: [criteriaData],
                                        tableData: reportData,
                                        mainHeader: mainHeader,
                                        isShowManageColumn: true,
                                        manageColumnID: manageColIdValue,
                                        colSpanMarker: markerField,
                                        hideHeader: true,
                                        serialNokey :'srNo',
                                        showColumnBorders: true,
                                        totalSubKey:3,
                                        isIncreFontSize: true,
                                    }
                                     if (isPdf) return exportPdf(reportData,allHeaders, true)
                                } else {
                                    mainHeader = summaryheaders.map((val) => ({
                                        ...val,
                                        align: val.xlCol.dataType === 'string' ? 'left' : 'right',
                                        export: val.exportHead,
                                        weight: 80
                                    }))
                                    reportPayload = {
                                        reportName,
                                        criteriaHeaders: criteriaHeaders,
                                        criteriaData: [criteriaData],
                                        tableData: reportData,
                                        mainHeader: mainHeader,
                                        hideHeader: true,
                                        serialNokey :'SN',
                                        showColumnBorders: true,
                                        isIncreFontSize: true,
                                    }
                                    if (isPdf) return exportPdf(reportData,mainHeader, true)
                                }
                                const rid = Date.now().toString()

                                if (!window.generatedReports) {
                                    window.generatedReports = {}
                                }

                                window.generatedReports[rid] = reportPayload

                                window.open(`/view-report?rid=${rid}`, "_blank")
                                setClickButton('')
                            }
                        } else {
                            updateAlert({ show: true, msg: res.ErrMessage })
                        }
                    })
            }
        }
    }
    const handleClick2 = () => {
        if (transactionType?.TransId === 1) {
            updateAlert({ show: true, msg: 'Booked Trans. Not Allowed' })
        } else if (destinationBranch.DestBranchID != 0) {
            updateAlert({ show: true, msg: `Please Select All Destination Branch and Try Again.` })
        } else if (diffInMonths(fromDate, toDate) !== 0) {
            updateAlertError({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' })
        } else {
            let url = urlValue.BookingReport
            let urlData = urlValue.BookingReportParams
            urlData.chk = loginData?.BusCrsCheckSum
            urlData.dtDateFrom = fromDate.format('DD-MMM-YYYY')
            urlData.dtDateTo = toDate.format('DD-MMM-YYYY')
            urlData.intCompanyId = loginData?.intCompanyID
            urlData.intBranchId = sourceBranch.SourceBranchID || 0
            urlData.intpaymenttype = paymentType.typeId
            urlData.intUserId = sourceBranchUser?.UserID || 0
            urlData.intLoggedInUSer = loginData?.intUserID
            urlData.Isrefund = transactionType?.TransId ? 2 : 0 //based on AllTransiction Dropdown
            urlData.intAllowViewAllReport = 1
            urlData.companyname = loginData?.strCompanyName
            urlData.intDestCityId = destinationCity.DestCityID || 0
            urlData.strDestCityName = destinationCity.DestCityID === 0 ? "--All--" : destinationCity.DestCityName
            urlData.isSummaryOnly = selReportView?.ReportId === "0" ? 1 : 0
            url = appendToUrl(url, urlData)
            window.open(url, '_blank')
        }
    }
    useEffect(() => {
        focusElemnt("fromDate")
    }, [])
    useEffect(() => {
        let updatedOptions = paymentModesWithAll.map(item => ({ ...item }));
        if (UseToPayAsCOD === 1) {
            const toPayIndex = updatedOptions.findIndex(item => item.typeId === 2);
            const codOption = updatedOptions.find(item => item.typeId === 4);
            if (toPayIndex !== -1 && codOption) {
                updatedOptions[toPayIndex] = {
                    ...codOption,
                    typeId: 2,
                    name: "COD",
                    roleRightsId: "COD"
                };
            }
            updatedOptions = updatedOptions.filter(item => item.typeId !== 4);
        }
        setPaymentOptions(updatedOptions);
    }, [UseToPayAsCOD]);
    useEffect(() => {
        if (intCompanyID) {
            const body = {
                intCompanyID: intCompanyID,
                UserID: intUserID
            }
            fetchChildCompanyList(body)
        }
    }, [ intCompanyID, intUserID])
    useEffect(() => {
        if (!isEmpty(roleRightsData) && intUserID) {
            setDisableBtn(!(roleRightsData?.AllowViewAllBranchReport || roleRightsData?.AllowBranchInchargeRights || loginData?.IsBranchAdmin || loginData?.IsMTPLAdmin || loginData?.IsAdmin))
            setDisableExcel(!(roleRightsData?.AllowExportExcel))
        }
    }, [roleRightsData, intUserID])
    useEffect(() => {
        if (AllowGroupofCompanies === 1) {
            const defaultCompany = ChildCompanyList.find((v) => v.CompanyID === loginData?.intCompanyID) || ChildCompanyList[0]
            setSelCompany(defaultCompany)
        } else {
            setSelCompany({
                CompanyID: loginData?.intCompanyID,
                CompanyName: loginData?.strCompanyName,
            })
        }
    }, [ChildCompanyList, AllowGroupofCompanies, loginData])
    const getLastNonNumericField = () => {
        const result = [];

        for (const obj of manageColumn) {
            if (obj?.xlCol?.dataType !== 'string') {
                break;
            }

            if (obj?.xlCol?.dataType === 'string') {
                result.push(obj.field);
            }
        }
        if(result?.length>0){
            return result[result?.length-1]
        }
        return manageColumn.find((obj) => obj?.field === 'MOP')?.field || manageColumn.find((obj) => obj?.field === 'STATUS')?.field ||manageColumn.find((obj) => obj?.field === 'ItemDetails')?.field || manageColumn?.[0]?.field || ''
    }
    const groupData = (arr = [], headers) => {
        const lengths = divideInNIntegers(headers.length, 3)
        let index = 0
        const pickedHeaders = []
        lengths.forEach((span) => {
            pickedHeaders.push(headers[index].field)
            index += span
        })
        const headerRow = headers.reduce((acc, col) => {
            acc[col.field] = col.header
            return acc
        }, { dataType: 'header' })

        const grouped = {};

        // Step 1: Group by IsRefund and PaymentMode
        arr = arr.map((v, i) => ({
            ...v,
            Valuation: Math.round(v.Valuation) || 0,
            CartageAmount: Math.round(v.CartageAmount) || 0,
        }))
        arr.forEach((val) => {
            const key = `${val.IsRefund}-${val.PaymentMode}`;
            if (!grouped[key]) grouped[key] = [];
            grouped[key].push(val);
        });

        const transform = (list) =>
            list.map((val, i) => ({
                ...val,
                srNo: i + 1,
                dataType: 'entry',
                 DstCityBranch: `${val.DestCityName}\n${val.DestBranchName}`,
                 BkgDtTimeBy:`${moment(val.BkgDtTime).format('DD-MMM-YY HH:mm')}\n${val.UserBooked}`,
                'Sender^^SenderGSTN': `${val.Sender}\n${val.SenderGSTN}`,
                'SenderMobileNo^^SenderEmailID': `${val.SenderMobileNo}\n${val.SenderEmailID}`,
                'RecMobileNo^^ReceiverEmailID': `${val.RecMobileNo}\n${val.ReceiverEmailID}`,
                'RecName^^RecGSTN': `${val.RecName}\n${val.RecGSTN}`,
                'BkgDtTime^^UserBooked': `${moment(val.BkgDtTime).format('DD-MMM-YY HH:mm')}\n${val.UserBooked}`,
                'LRNO^^ManualLRNo': val.LRNO + '\n' + val.ManualLRNo,
                'DestCityName^^DestBranchName': val.DestCityName + '\n' + val.DestBranchName,
                'ConsignmentType^^Quantity': val.ConsignmentType + '\n' + val.Quantity,
                BookedResponse: val.BookedResponse ? JSON.parse(val.BookedResponse)?.TransID : '',
                DeliveredResponse: val.DeliveredResponse ? JSON.parse(val.DeliveredResponse)?.TransID : '',
            }))

        const summarize = (list) =>
            list.reduce((acc, val) => {
                acc.Quantity += +val.Quantity || 0;
                acc.Freight += +val.Freight || 0;
                acc.CartageAmount += +val.CartageAmount || 0;
                acc.HamaliCharges += +val.HamaliCharges || 0;
                acc.DocumentCharges += +val.DocumentCharges || 0;
                acc.Valuation += +val.Valuation || 0;
                acc.OtherCharges += +val.OtherCharges || 0;
                acc.BookingGST += +val.BookingGST || 0;
                acc.NetAmount += +val.NetAmount || 0;
                return acc;
            }, {
                Quantity: 0,
                Freight: 0,
                CartageAmount: 0,
                HamaliCharges: 0,
                DocumentCharges: 0,
                Valuation: 0,
                OtherCharges: 0,
                BookingGST: 0,
                NetAmount: 0,
            });

        const finalData = [];
        const grandTotal = {
            Quantity: 0,
            Freight: 0,
            CartageAmount: 0,
            HamaliCharges: 0,
            DocumentCharges: 0,
            Valuation: 0,
            OtherCharges: 0,
            BookingGST: 0,
            NetAmount: 0,
        };

        const groupedEntries = Object.entries(grouped);
        if (transactionType?.TransId === 0) {
            groupedEntries.sort(([firstKey], [secondKey]) => {
                const [firstIsRefund] = firstKey.split('-');
                const [secondIsRefund] = secondKey.split('-');
                return Number(firstIsRefund) - Number(secondIsRefund);
            });
        }
        const lastNonNumericField = getLastNonNumericField()
        const totalLabelSpanIndex = headers.findIndex((header) => header.field === lastNonNumericField)
        const totalLabelSpan = totalLabelSpanIndex >= 0 ? totalLabelSpanIndex + 1 : 1
        groupedEntries.forEach(([key, list]) => {
            const [isRefund, paymentMode] = key.split('-');
            const transformed = transform(list);
            const summary = summarize(transformed);

            Object.keys(grandTotal).forEach(k => {
                grandTotal[k] += summary[k] || 0;
            });
            finalData.push({
                colSpan: Object.fromEntries(pickedHeaders.map((key, i) => [key, lengths[i] || 1])),
                align: { [pickedHeaders[0]]: 'left', [pickedHeaders[1]]: 'center', [pickedHeaders[2]]: 'right' },
                [pickedHeaders[0]]: `Source City :${sourceCity?.SourceCityName}`,
                [pickedHeaders[1]]: `Destination City:${destinationCity?.DestCityName}`,
                [pickedHeaders[2]]: `Trans: ${isRefund === '0' ? 'Booked' : 'Refund'} | Payment Mode: ${paymentMode}`,
                dataType: 'subHeader',
                totalSubKey:3,
            })
            finalData.push({ ...headerRow })
            finalData.push(...transformed);
            Object.keys(summary).forEach((k) => {
                summary[k] = Number(summary[k].toFixed(2))
            })
            finalData.push({
                ...summary,
                'ConsignmentType^^Quantity': summary.Quantity,
                colSpan: { [pickedHeaders[0]]: totalLabelSpan },
                [pickedHeaders[0]]: `Total: Src.City ${sourceCity?.SourceCityName} / Dest.City ${destinationCity?.DestCityName}, Trans: ${isRefund === "0" ? "Booked" : "Refund"} | PaymentMode: ${paymentMode}`,
                dataType: 'total',
                align: { [pickedHeaders[0]]: 'right' },
                IsRefund: Number(isRefund),
            });
        });
        if (Object.keys(grouped).length > 1) {
            Object.keys(grandTotal).forEach((k) => {
                grandTotal[k] = Number(grandTotal[k].toFixed(2))
            })
            finalData.push({
                ...grandTotal,
                'ConsignmentType^^Quantity': grandTotal.Quantity,
                align:{ [pickedHeaders[0]]:'right'},
                colSpan: { [pickedHeaders[0]]: totalLabelSpan },
                [pickedHeaders[0]]: `Net Total: Src.City All Cities / Dest.City All Cities, Trans: Booked + Refund`,
                dataType: 'total',
                IsRefund: 0,
            })
        }


        return finalData;
    };
   
    const criteriaHeaders = [
        { field: 'selCompany', header: 'Selected Company', textAlign: 'left' },
        { field: 'fromDate', header: 'From Booking Date', textAlign: 'left' },
        { field: 'toDate', header: 'To Booking  Date', textAlign: 'left' },
        { field: 'sourceCity', header: 'Source City', textAlign: 'left' },
        { field: 'sourceBranch', header: 'Source Branch', textAlign: 'left' },
        { field: 'sourceBranchUser', header: 'Source Branch User', textAlign: 'left' },
        { field: 'destinationCity', header: 'Destination City', textAlign: 'left' },
        { field: 'destinationBranch', header: 'Destination Branch', textAlign: 'left' },
        { field: 'paymentType', header: 'Payment Type', textAlign: 'left' },
        { field: 'transactionType', header: 'TransactionType', textAlign: 'left' },
        { field: 'selReportView', header: 'Report View`', textAlign: 'left' },
    ]
    const criteriaData = {
        selCompany: selCompany?.CompanyName || '',
        fromDate: fromDate.format('DD-MM-YYYY') || '',
        toDate: toDate.format('DD-MM-YYYY') || '',
        sourceCity: sourceCity?.SourceCityName || '',
        sourceBranch: sourceBranch?.SourceBranchName || '',
        sourceBranchUser: sourceBranchUser?.UserBooked || '',
        destinationCity: destinationCity?.DestCityName || '',
        destinationBranch: destinationBranch?.DestBranchName || '',
        paymentType: paymentType?.name || '',
        transactionType: transactionType?.TransType || '',
        selReportView: selReportView?.ReportView || '',
        dataType: 'entry',
    }
    const formatData = (ownBookingTableData) => {
        if (!manageColumn?.length) {
            updateAlertError({ show: true, msg: 'manageColumn not ready yet', nextId: '' })
            return [];
        }
        if (ownBookingTableData?.status !== 'Success') return

        const isDetailed = selReportView?.ReportView === 'Detailed'
        const isSummary = selReportView?.ReportView === 'Summary'
        let reportValue = []
        if (isDetailed) {
            const raw = ownBookingTableData?.Data?.Table?.map((item)=>({
                ...item,
                STATUS: loginCountryId===2?item.STATUS==='BRANCH RECEIVED'?'Sc. Tr. Receive':item.STATUS?.replace('DELIVERY RECEIVED',' Assign Delivery').replace('Out Delivered','Pending Out Delivery'):item.STATUS
            }))
            if (!raw) return
            const headers = manageColumn.filter((obj) => obj.isSelected)
            if (!headers?.length) {
                updateAlertError({ show: true, msg: 'No selected headers', nextId: '' })
                return [];
            }
            if (raw.length === 0) {
                const noData = [
                    {
                        [headers[0].field]: 'No results found. Please refine your search parameters and search again.',
                        dataType: 'total',
                        colSpan: { [headers[0].field]: headers.length },
                        align: { [headers[0].field]: 'center' },
                    },
                ]
                
                return noData
            }
            let filtered = raw
            if (transactionType?.TransId === 1) {
                filtered = raw.filter((r) => r.IsRefund == 0)
            } else if (transactionType?.TransId === 2) {
                filtered = raw.filter((r) => r.IsRefund == 1)
            }
            const finalData = groupData(filtered, headers)
            if (finalData.length === 0) {
                const noData = [
                    {
                        [headers[0].field]: 'No results found. Please refine your search parameters and search again.',
                        dataType: 'total',
                        colSpan: { [headers[0].field]: headers.length },
                        align: { [headers[0].field]: 'center' },
                    },
                ]
                return noData
            } else {
                return finalData
            }
        }

        if (isSummary) {
            const tbl1 = ownBookingTableData?.Data?.Table1 ?? []
            if (tbl1.length === 0) {
                return []
            }
            const colspans = devideInTwoIntegers(summaryheaders.length)
            const data = tbl1.map((v, i) => ({
                ...v,
                SN: i + 1,
                DocumentCharges: v.DocumentCharges || 0,
                Valuation: Math.round(v.Valuation) || 0,
                CartageAmount: Math.round(v.CartageAmount) || 0,
                dataType: 'entry',
            }))
            const totals = data.reduce(
                (t, v) => {
                    if (v.isTotal || v.isHeading) return t
                    t.LRCount += +v.LRCount || 0
                    t.ItemUnits += +v.ItemUnits || 0
                    t.Freight += +v.Freight || 0
                    t.CartageAmount += +v.CartageAmount || 0
                    t.HamaliCharges += +v.HamaliCharges || 0
                    t.DocumentCharges += +v.DocumentCharges || 0
                    t.Valuation += +v.Valuation || 0
                    t.OtherCharges += +v.OtherCharges || 0
                    t.BookingGST += +v.BookingGST || 0
                    t.Amount += +v.Amount || 0
                    t.RefundAmt += +v.RefundAmt || 0
                    t.NetAmount += +v.NetAmount || 0
                    return t
                },
                {
                    LRCount: 0,
                    ItemUnits: 0,
                    Freight: 0,
                    CartageAmount: 0,
                    HamaliCharges: 0,
                    DocumentCharges: 0,
                    Valuation: 0,
                    OtherCharges: 0,
                    BookingGST: 0,
                    Amount: 0,
                    RefundAmt: 0,
                    NetAmount: 0,
                }
            )
            Object.keys(totals).forEach((k) => {
                totals[k] = Number(totals[k].toFixed(2))
            })
            data.push({ ...totals, SN: 'Grand Total', dataType: 'total', colSpan: { SN: 2 }, align:{SN: 'right'} })
            const headerObject = summaryheaders.reduce(
                (acc, v) => {
                    acc[v.field] = v.headerName
                    return acc
                },
                { dataType: 'header' }
            )
            data.unshift(headerObject)
            data.unshift({
                [summaryheaders[0].field]: `Source City: ${sourceCity?.SourceCityName}`,
                [summaryheaders[colspans[0]].field]: `Destination City: ${destinationCity?.DestCityName}`,
                dataType: 'subHeader',
                colSpan: { SN: colspans[0], [summaryheaders[colspans[0]].field]: colspans[1] },
                totalSubKey:3,
            })
            data.unshift({
                SN: `Booking Report`,
                dataType: 'header',
                colSpan: { SN: summaryheaders.length },
            })
            return data
        }
    }
 
    let Updatedcolumn = ownBookingDetailedColumnsWithFormattedLRTwo(UseFormattedLRinReports, loginCountryId, UseToPayAsCOD,intCompanyID)
    useEffect(() => {
        const getLocalData = (key) => {
            return new Promise((resolve) => {
                const localData = localStorage.getItem(key)
                resolve(localData ? JSON.parse(localData) : null)
            })
        }
        const updateColumnDetails = async () => {
            try {
                if (BookingReportPortrait === 1) {
                    let usedCols = []
                    const ownBookingDetailedForPotrateCol = await getLocalData('ownBookingDetailedColumnsPotrate')
                    usedCols = ownBookingDetailedForPotrateCol || ownBookingDetailedColumnsForPotrate

                    if (UseFormattedLRinReports !== 3) {
                        usedCols = usedCols.filter((item) => item.field !== 'FormattedLRNO')
                    }
                    if (!IsHamaliInBookingReport) {
                        usedCols = usedCols.filter((item) => !['HamaliCharges', 'DocumentCharges'].includes(item.field))
                    }
                    setManageColumn(usedCols)
                } else if (DefaultCurrencyID === 2) {
                    const UpdatedLeymacolumns = await getLocalData('ownBookingLeymaDetailedColumns21')
                    let usedCols = UpdatedLeymacolumns || ownBookingDetailedColumnsForLeyma
                    setManageColumn(usedCols)
                } else {
                    const Updatedcolumns = await getLocalData('ownBookingDetailedColumns223')
                    let usedCols = Updatedcolumns || Updatedcolumn
                    usedCols = usedCols
                        .map((col) => {
                            if (DefaultCurrencyID === 2) {
                                if (col.field === 'Valuation') {
                                    return {
                                        ...col,
                                        header: 'Insu.\nChrg.',
                                        exportHead: 'Insurance Charge',
                                    }
                                }
                                if (col.field === 'Sender^^SenderGSTN') {
                                    return {
                                        ...col,
                                        header: 'Sndr. Name',
                                        exportHead: 'Sender Name',
                                    }
                                }
                                if (col.field === 'RecName^^RecGSTN') {
                                    return {
                                        ...col,
                                        header: 'Rcvr. Name',
                                        exportHead: 'receiver Name',
                                    }
                                }
                                if (col.field === 'BookingGST') {
                                    return false
                                }
                            }
                            if (col.field === 'CartageAmount' && intCompanyID === GT_COMPANY_ID) {
                                return {
                                    ...col,
                                    header: 'Addl. \nCartage',
                                    exportHead: 'Additional Cartage',
                                }
                            }
                            return col
                        })
                        .filter(Boolean)
                    setManageColumn(usedCols)
                }
            } catch (error) {
                setManageColumn([])
                console.error(error)
            }
        }

        updateColumnDetails()
    }, [UseFormattedLRinReports, BookingReportPortrait, DefaultCurrencyID, intCompanyID, IsHamaliInBookingReport])
    const onSaveColumns = (items) => {
        setManageColumn(items)
        if (BookingReportPortrait === 1) {
            localStorage.setItem('ownBookingDetailedColumnsPotrate', JSON.stringify(items))
        } else if (DefaultCurrencyID === 2) {
            localStorage.setItem('ownBookingLeymaDetailedColumns21', JSON.stringify(items))
        } else {
            localStorage.setItem('ownBookingDetailedColumns223', JSON.stringify(items))
        }
    }
    const selectedFields =manageColumn?.length? manageColumn.filter((item) => item.isSelected).reduce((result, item) => ({ ...result, [item.field]: true }), {}) :{}
    const selectedSourceCity = (obj) => {
        setShowReport(false)
        setSourceCity(obj)
        setSourceBranch(removeDuplicatesFromArray(sourceBranchData, "SourceBranchID").filter((val) => val.SourceCityID === obj?.SourceCityID || obj?.SourceCityID === 0 || val.SourceBranchID === 0)?.[0])
    }

    const selectedSourceBranch = (obj) => {
        setShowReport(false)
        setSourceBranch(obj)
        setSourceBranchUser(removeDuplicatesFromArray(sourceBranchUserData, 'UserID')?.filter((val) => val?.SourceBranchID === obj?.SourceBranchID || obj?.SourceBranchID === 0 || val?.UserID === 0)?.[0])
    }
    const selectedDestCity = (obj) => {
        setShowReport(false)
        setDestinationCity(obj)
        setSelDestinationBranch(removeDuplicatesFromArray(destinationBranchdata, "DestBranchID").filter((val) => val.DestCityID === obj?.DestCityID || obj?.DestCityID === 0 || val.DestBranchID === 0)?.[0])
    }
    return (
        <>
            <Box sx={sx.reportFlex}>
                <Item sx={sx.itemsxGrow}>
                    <DropDownOA
                        id="selectCompnay"
                        label="Selected Company"
                        data={ChildCompanyList}
                        defaultvalue={selCompany?.CompanyName}
                        disabled={AllowGroupofCompanies === 1 ? false : true}
                        onSelect={(val) => setSelCompany(val)}
                        dataKey={`CompanyName`}
                        idKey={`CompanyID`}
                        width="100%"
                    />
                </Item>
                <Item sx={filterItemSx} className="input--container bookingDatePicker">
                    <Datepicker
                        value={fromDate}
                        name={'from_booking_date'}
                        dateDiff={365}
                        // calcDiffDate(new Date(), new Date("2021,04,01"))
                        label={lb.fromBookingDate}
                        id={'fromDate'}
                        nextId={'toDate'}
                        prevId={'fromDate'}
                        dateChange={(date) => { setFromDate(date); focusElemnt('toDate') }}
                        width={filterInputWidth}
                    />
                </Item>
                <Item sx={filterItemSx} className="input--container bookingDatePicker">
                    <Datepicker
                        value={toDate}
                        name={'to_booking_date'}
                        label={lb.toBookingDate}
                        id={'toDate'}
                        nextId={'OwnBookingGoBtn'}
                        prevId={'fromDate'}
                        dateChange={(date) => { setToDate(date); focusElemnt('OwnBookingGoBtn') }}
                        width={filterInputWidth}
                    />
                </Item>
                <Item sx={sx.itemsx}>
                    <Button
                        id="OwnBookingGoBtn"
                        variant="contained"
                        className="go click-button"
                        onClick={handleGoClick}
                        onKeyDown={(e) => navigation3(e, 'sourceCity', 'fromDate', handleGoClick)}
                    >
                        GO
                    </Button>
                </Item>
                <Item sx={filterItemSx}>
                    <DropDownOA
                        label="Source City"
                        id="sourceCity"
                        nextId={'sourceBranch'}
                        prevId={'OwnBookingGoBtn'}
                        data={removeDuplicatesFromArray(sourceCityData, 'SourceCityID') || []}
                        defaultvalue={sourceCity?.SourceCityName || sourceCity}
                        dataKey={`SourceCityName`}
                        idKey={`SourceCityID`}
                        disabled={disableBtn}
                        onSelect={(obj) => selectedSourceCity(obj)}
                        width={filterInputWidth}
                    />
                </Item>
                <Item sx={filterItemSx}>
                    <DropDownOA
                        label="Source Branch"
                        id="sourceBranch"
                        nextId={'sourceBranchUser'}
                        prevId={'sourceCity'}
                        disabled={disableBtn && roleRightsData?.AllowViewAllBranchOfCityReport == 0}
                        // data={removeDuplicatesFromArray(sourceBranchData, 'SourceBranchID') || []}
                        data={
                            removeDuplicatesFromArray(sourceBranchData, 'SourceBranchID').filter(
                                (val) => val.SourceCityID === sourceCity?.SourceCityID || sourceCity?.SourceCityID === 0 || val.SourceBranchID === 0
                            ) || []
                        }
                        defaultvalue={sourceBranch?.SourceBranchName || sourceBranch}
                        dataKey={`SourceBranchName`}
                        idKey={`SourceBranchID`}
                        onSelect={(val) => selectedSourceBranch(val)}
                        width={filterInputWidth}
                        listWidth={'250px'}
                    />
                </Item>
                <Item sx={filterItemSx}>
                    <DropDownOA
                        label="Source Branch User"
                        id="sourceBranchUser"
                        nextId={'destinationCity'}
                        prevId={'sourceBranch'}
                        disabled={loginData?.intCompanyID === GT_COMPANY_ID ? false : disableBtn && roleRightsData?.AllowViewAllBranchOfCityReport == 0}
                        defaultvalue={sourceBranchUser?.UserBooked || sourceBranchUser}
                        data={
                            removeDuplicatesFromArray(sourceBranchUserData, 'UserID')?.filter(
                                (val) => val?.SourceBranchID === sourceBranch?.SourceBranchID || sourceBranch?.SourceBranchID === 0 || val?.UserID === 0
                            ) || []
                        }
                        dataKey={`UserBooked`}
                        idKey={`UserID`}
                        onSelect={(val) => {
                            setShowReport(false)
                            setSourceBranchUser(val)
                        }}
                        width={filterInputWidth}
                    />
                </Item>
                <Item sx={filterItemSx}>
                    <DropDownOA
                        label="Destination City"
                        id="destinationCity"
                        nextId={'destinationBranch'}
                        prevId={'sourceBranchUser'}
                        defaultvalue={destinationCity?.DestCityName || destinationCity}
                        data={
                            removeDuplicatesFromArray(destinationCityData, 'DestCityID').filter(
                                (val) => val.DestCityID !== sourceCity?.SourceCityID || val.DestCityID === 0
                            ) || []
                        }
                        dataKey={`DestCityName`}
                        idKey={`DestCityID`}
                        onSelect={(obj) => selectedDestCity(obj)}
                        width={filterInputWidth}
                    />
                </Item>
                <Item sx={filterItemSx}>
                    <DropDownOA
                        label="Destination Branch"
                        id="destinationBranch"
                        nextId={'paymentType'}
                        prevId={'destinationCity'}
                        defaultvalue={destinationBranch?.DestBranchName || destinationBranch}
                        data={
                            removeDuplicatesFromArray(destinationBranchdata, 'DestBranchID').filter(
                                (val) => val.DestCityID === destinationCity?.DestCityID || destinationCity?.DestCityID === 0 || val.DestBranchID === 0
                            ) || []
                        }
                        dataKey={`DestBranchName`}
                        idKey={`DestBranchID`}
                        onSelect={(obj) => {
                            setShowReport(false)
                            setSelDestinationBranch(obj)
                        }}
                        width={filterInputWidth}
                        listWidth={'250px'}
                    />
                </Item>
                <Item sx={filterItemSx}>
                    <DropDownOA
                        label={'Payment Type'}
                        // data={paymentModesWithAll || []}
                        data={(paymentModesWithAll || []).map((item) => {
                            if (UseToPayAsCOD === 1) {
                                if (item.typeId === 2) {
                                    return { ...item, name: 'COD' };
                                }
                                if (item.typeId === 7) {
                                    return { ...item, name: 'COD Manual' };
                                }
                                if (item.typeId === 9) {
                                    return { ...item, name: 'COD DDDV' };
                                }
                                if (item.typeId === 4) {
                                    return null;
                                }
                            }
                            return item;
                        }).filter(Boolean)
                        }
                        id="paymentType"
                        nextId={'TransactionType'}
                        prevId={'destinationBranch'}
                        defaultvalue={paymentType?.name || ''}
                        width="100%"
                        searchPlaceholder={`Search By Payment Type`}
                        tabIndex="2"
                        dataKey={`name`}
                        idKey={`typeId`}
                        onSelect={(val) => {
                            setShowReport(false)
                            setPaymentType(val)
                        }}
                    />
                </Item>
                <Item sx={filterItemSx}>
                    <DropDownOA
                        label="Txn.Type"
                        id="TransactionType"
                        nextId={'ReportView'}
                        prevId={'paymentType'}
                        defaultvalue={transactionType?.TransType || ''}
                        data={transType}
                        onSelect={(val) => {
                            setShowReport(false)
                            setTransactionType(val)
                        }}
                        dataKey={`TransType`}
                        idKey={`TransId`}
                        width={filterInputWidth}
                    />
                </Item>
                <Item sx={filterItemSx}>
                    <DropDownOA
                        id="ReportView"
                        nextId={'LrStatus'}
                        prevId={'TransactionType'}
                        label="Report View"
                        data={reportView}
                        defaultvalue={selReportView?.ReportView || ''}
                        dataKey={`ReportView`}
                        onSelect={(val) => {
                            setShowReport(false)
                            setSelReportView(val)
                        }}
                        idKey={`ReportId`}
                        width={filterInputWidth}
                    />
                </Item>
                <Item sx={filterItemSx}>
                    <DropDownOA
                        id="LrStatus"
                        nextId={'OwnChechBox'}
                        prevId={'ReportView'}
                        label="LR Status"
                        data={lrStatusView}
                        defaultvalue={status?.LrStatus || ''}
                        dataKey={`LrStatus`}
                        idKey={`LrId`}
                        width={filterInputWidth}
                        listWidth={'250px'}
                        onSelect={(val) => {
                            setShowReport(false)
                            setStatus(val)
                        }}
                    />
                </Item>
                <FormControlLabel
                    value="end"
                    id="OwnChechBox"
                    prevId={'LrStatus'}
                    nextId={"OwnSplitBtn"}
                    control={<Checkbox id={id.onlyRefund} />}
                    className={`${checkCrossinglr ? 'selcheck' : 'unselcheck'}`}
                    label="Include Crossing LRs?"
                    labelPlacement="end"
                    checked={checkCrossinglr}
                    onChange={() => {
                        setCheckCrossinglr(!checkCrossinglr)
                    }}
                    onKeyDown={(e) => {
                        navigation3(e, 'OwnSplitBtn', 'LrStatus')
                    }}
                />
                {isFromUrl ?
                    <Button variant="contained" sx={{ width: '100%', height: '40px', mb: 1 }} className="btn btn-primary" onClick={() => fetchData(true)} >
                        DOWNLOAD PDF
                    </Button> : <>
                <Item
                    sx={sx.itemsx}
                    style={{ cursor: 'pointer' }}
                    onKeyDown={(e) => navigation3(e, showReport ? disableExcel ? "OwnBookingReportPdfBtn" : "ExpToExlbtn" : 'fromDate', 'OwnChechBox', () => fetchData())}
                >
                    <SplitButton
                        id1={'OwnSplitBtn'}
                        options={['GENERATE NEW FORMAT', 'GENERATE OLD FORMAT']}
                        prevID={id.summaryCheck}
                        onClick1={()=>fetchData(false)}
                        onClick2={handleClick2}
                    />
                </Item>
                <Item sx={sx.itemsx} className="flex-center-all" onClick={reset}>
                    <RefreshSvg />
                </Item></>}
            </Box>
        </>
    )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { getOwnBookingFilterData, getOwnBookingTableData, getCargoSettingFilterData, updateAlert, updateAlertError, updateModal }
export default connect(mapStateToProps, mapDispatchToProps)(OwnBookingsNew)
